import { Component } from 'vue-property-decorator';


import { Type } from "src/utils";

/**
 * 表示一个分销商品状态。
 * @enum
 * @version 1.0.0
 */
enum DistributionGoodsStatus
{
    /**
     * 取消
     * @member
     */
    cancel = 0,

    /**
     * 审核中
     * @member
     */
    verify,

    /**
     * 未通过
     * @member
     */
    notPass,

    /**
     * 已发布
     * @member
     */
    publish,

    /**
     * 已下架
     * @member
     */
    pull
}

/*
* 定义枚举元数据。
*/
Type.setMetadata(DistributionGoodsStatus,
{
    cancel:
    {
        alias: "取消",
        description: ""
    },
    verify:
    {
        alias: "审核中",
        description: ""
    },
    notPass:
    {
        alias: "未通过",
        description: ""
    },
    publish:
    {
        alias: "已发布",
        description: ""
    },
    pull:
    {
        alias: "已下架",
        description: ""
    }
});

export default DistributionGoodsStatus;
